import React from "react";

const videoSource =
  "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4";

interface SimpleVideoPlayerProps {
  src?: string;
  poster?: string;
  width?: string | number;
  height?: string | number;
  style?: React.CSSProperties;
}

export const Video: React.FC<SimpleVideoPlayerProps> = ({
  src = videoSource,
  poster,
  width = "100%",
  height = "auto",
  style = {},
}) => {
  return (
    <video
      src={src}
      poster={poster}
      width={width}
      height={height}
      controls
      playsInline
      preload="metadata"
      style={{ borderRadius: "12px", background: "black",...style }}
      onError={(e) => {
        console.error("Error cargando el video:", e);
      }}
    >
      Tu navegador no soporta el reproductor de video.
    </video>
  );
};